var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    {
      ref: "target",
      staticClass: "q-caption",
      attrs: {
        flat: "",
        size: "md",
        "no-wrap": "",
        color: "secondary",
        label: _vm.value.length + " " + _vm.column.field
      },
      on: {
        click: function($event) {
          _vm.open = !_vm.open
        }
      }
    },
    [
      _c(
        "q-popover",
        {
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _c(
            "q-list",
            { attrs: { separator: "", link: "" } },
            _vm._l(_vm.value, function(item, index) {
              return _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ],
                  key: index,
                  staticClass: "text-truncate q-caption"
                },
                [
                  _c("q-item-main", {
                    attrs: { label: item.name, subtitle: item.contactType }
                  })
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }